import React, { useEffect, useState } from 'react';
import styles from './systemMaintenance.module.css';
import { queryString, redirectToLogin } from '../../common/CommonTools';
import BblButton from '../../component/buttons/bblButton';
import { GenericNotificationPage } from '../genericNotificationPage/genericNotificationPage';

export const redirectToMaintenancePage = (errMsg?: string): void => {
  const params = new URLSearchParams(errMsg ? { errMsg } : {});
  window.location.href = `/Maintenance?${params.toString()}`;
};

export const SystemMaintenance = (): JSX.Element => {
  return (
    <GenericNotificationPage
      iconUrl={'assets/bigBangLab/undermaintenance.png'}
      title="Server Maintenance"
      subtitle={`We sincerely apologize for the inconvenience caused.
      Big Bang Lab is currently under maintenance and will return shortly.
      Please try again later.`}
      errMsg={queryString().errMsg}
      button={
        <BblButton mute color="primary" size="medium" onClick={redirectToLogin}>
          Back To Home
        </BblButton>
      }
    />
  );
};
